import {useCallback} from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

export const SelectNameAndTypeCmpt = ({
  isFetching,
  isEditStepper,
  campaignName,
  setCampaignName,
  campaignType,
  setCampaignType,
}: {
  isFetching: boolean;
  isEditStepper: boolean;
  campaignName: string;
  setCampaignName: React.Dispatch<React.SetStateAction<string>>;
  campaignType: string[];
  setCampaignType: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = e.target.value;
      setCampaignName(value.trimStart());
    },
    [setCampaignName],
  );

  const handleOnChange = useCallback(
    (type: string) => {
      if (campaignType.includes(type)) {
        setCampaignType(prev => {
          return prev.filter(val => val !== type);
        });
      } else {
        setCampaignType(prev => [...prev, type]);
      }
    },
    [campaignType, setCampaignType],
  );

  if (isEditStepper && isFetching) {
    return (
      <>
        <Skeleton variant='text' width={150} height={30} />
        <Skeleton
          variant='rectangular'
          width={250}
          height={40}
          sx={{marginBottom: 2}}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '250px',
          }}>
          <Skeleton variant='rectangular' width={100} height={40} />
          <Skeleton variant='rectangular' width={100} height={40} />
        </Box>
      </>
    );
  }

  return (
    <>
      <Typography className='font-bold text-16 mb-2'>
        Enter Name/Type
      </Typography>

      <TextField
        size='small'
        placeholder='Enter Campaign Name'
        className='mb-3 w-300'
        onChange={handleNameChange}
        value={campaignName}
      />

      <Stack direction={'row'} className=' mb-2'>
        <FormControlLabel
          control={
            <Checkbox
              checked={campaignType.includes('GameTime')}
              onClick={() => handleOnChange('GameTime')}
            />
          }
          label={<Typography>GameTime</Typography>}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={campaignType.includes('Neptune Radio')}
              onClick={() => handleOnChange('Neptune Radio')}
            />
          }
          label={<Typography>Neptune Radio</Typography>}
        />
      </Stack>
    </>
  );
};
